
import {FC} from "react";

import React from 'react';

import CorrectionForm from "../../forms/claim-handling-forms/correction-form";

interface Interface{
    partSource: any;
    requestId: any;
    mode?: "View" | "AddNew";
    
}

const CorrectionScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <CorrectionForm
                    requestId={props.requestId}
                    mode={props.mode}
                    partSource={props.partSource}
                />
            
    );
}
export default CorrectionScreen;
